import { PersonOutline } from "@mui/icons-material";
import { purple } from "@mui/material/colors";
import { isEmpty, isNil } from "lodash";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import CommentAttachmentChip from "../shared/CommentAttachmentChip";

// Property Preview Items
const RenderedPreviewBorrowerItems = ({ loan, ids, onClick, onDelete }) => {
  const navigate = useNavigate();

  const handleOnClick = useCallback(
    (id) => {
      navigate(`/loan/${loan?.loanNumber}/borrowers/${id}`);
    },
    [loan?.loanNumber, navigate]
  );

  const getBorrowerNameById = useCallback((loan, id) => {
    const borr = loan?.borrowers?.find((b) => b._id === id);

    if (isNil(borr)) {
      return "Unknown";
    }
    return `${borr.firstName || ""} ${borr.lastName || ""}`;
  }, []);

  if (isEmpty(ids)) {
    return null;
  }
  return ids.map((id) => (
    <CommentAttachmentChip
      key={id}
      attachmentId={id}
      background={purple[50]}
      color={purple[800]}
      icon={<PersonOutline className="thin" />}
      onClick={() => handleOnClick(id)}
      onDelete={onDelete}
    >
      {getBorrowerNameById(loan, id)}
    </CommentAttachmentChip>
  ));
};

export default RenderedPreviewBorrowerItems;
